var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('img',{staticClass:"page-img",attrs:{"src":require("../../static/no-jurisdiction.png"),"alt":""}}),_c('div',{staticClass:"big-title"},[_vm._v("提示："+_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }